import { API } from "@/services"

export const SYSTEM_INFO_ENDPOINTS = {
  get(params={}){
    return API.Axios.universal_ai.v1.request({
      url: `system-info`,
      method: 'GET',
      params,
    })
  },
  chart(params={}){
    return API.Axios.universal_ai.v1.request({
      url: `system-info/chart`,
      method: 'GET',
      params,
    })
  },
}